import { render } from "./catalogos.vue?vue&type=template&id=5ca834f2"
import script from "./catalogos.vue?vue&type=script&lang=js"
export * from "./catalogos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__